<script>
import componentEditorMixin from '@/components/ProductComponents/CreateComponents/componentEditorMixin.js'
import API from "../../../../../config/api";
export default {
  name: "cameraEditor",
  mixins: [componentEditorMixin],
  data() {
    return {
      snList: [],
    }
  },
  mounted() {
    this.getSnList();
  },
  methods: {
    getSnList() {
      this.$axiosRequest({
        url: API.getDeviceList,
        method: 'POST',
        data: {
          companyId: this.companyId,
          device_type: 3
        },
        header: API.header,
        success: res => {
         // console.log("访问成功",res)
          let list = res.data["deviceList"]
          for (let i = 0; i < list.length; i++) {
            this.snList.push(list[i].sn)
          }
        }
      });
    }
  },
  computed: {
    specificForms() {
      return (
          <div class="specificForms">
            <el-collapse-item class="specificForm" title="摄像头效果选项" name="2">
              <template slot="default">
                <div class="specificForm">
                  <el-form id="CrossFourForm" props={{model: this.newSettings}} ref="CrossFourForm"
                           label-style={this.formLabelStyle}>
                    <el-form-item label="绑定设备序列号" prop="sn" label-position={this.labelPosition}>
                      <el-select style={{width: "90px"}} size="mini"
                                 {...{
                                   attrs: {
                                     value: this.newSettings.sn,  // 存放变量name
                                   }
                                 }}
                                 {...{
                                   on: {
                                     'input': val => {
                                       this.newSettings.sn = val
                                       this.handleConfirmBtnClick()
                                     },
                                   }
                                 }}>
                        {
                          ...this.snList.map(sn => {
                            return sn === this.newSettings.sn ? (
                                <el-option label={sn} value={sn} selected={true}>{sn}</el-option>
                            ) : (
                                <el-option label={sn} value={sn}>{sn}</el-option>
                            )
                          })
                        }
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
              </template>
            </el-collapse-item>
          </div>
      )
    }
  },
}
</script>

<style scoped>

</style>